<app-header></app-header>
<div class="mainwrapper">
  <div class="new-container admin_dashboard_list perrenial_dashboard_container">
    <app-login-info></app-login-info>

    <div class="Perennial_mandalism_mail">

      <ng-container *ngIf="subscribeLoader">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-container>
      <div class="data_section_main"  *ngIf="memberShipData">
        <div class="data_sec_wrpr">
          <div class="all_data_sub_wrpr_sec">
            <img src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/mail_icon_img.webp" />
            <h5><strong>Email:</strong> {{ memberShipData.email }}</h5>
          </div>
          <div class="all_data_sub_wrpr_sec">
            <img
              src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/membership_type_icon_img.webp" />
            <h5> <strong>Membership Type:</strong> {{ memberShipData.membership_type }}</h5>
          </div>
          <div class="all_data_sub_wrpr_sec" >
            <img
              src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/people.png" />
            <h5>
              <strong>Total Members:</strong>
              {{ memberShipData.memberCount <= 0 ? 1 : memberShipData.memberCount }}<i (click)="redirecttoAditionalpage()" class="fa fa-pencil" aria-hidden="true"></i>
            </h5>
          </div>
          <div class="all_data_sub_wrpr_sec">
            <img
              src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/amount_icon_img.webp" />
            <h5><strong>Amount:</strong> ${{ memberShipData.amount }}/month</h5>
          </div>
          <div class="all_data_sub_wrpr_sec">
            <img
              src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/created_date_icon_img.webp" />
            <h5>
              <strong>Created Date:</strong>
              {{ memberShipData.created_date | date : "EEEE, MMMM d, y, h:mm:ss a"}}
            </h5>
          </div>
          <div class="all_data_sub_wrpr_sec">
            <img
              src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/created_date_icon_img.webp"
            />
            <h5>
              <strong>Subscription Renewal Date:</strong>
              {{
                cookieData?.userinfo?.perennial_current_period_end | date:'EEEE, MMMM d, y'
              }}
            </h5>
          </div>
          <div *ngIf="
              !cookieData?.userinfo?.perennial_subscription_id" class="all_data_sub_wrpr_sec">
            <img
              src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/subs_status.webp"
            />
            <h5>
              <strong>Status Confirmation:</strong>
              {{
                cookieData?.userinfo?.perennial_mandalism_status == 'subscription running'
                  ? 'Your Perennial Access is Active'
                  : 'Your Perennial Access is Inactive'
              }}
            </h5>
          </div>
  
          <div
            *ngIf="
              cookieData?.userinfo?.perennial_subscription_id && cookieData?.userinfo?.perennial_subscription_status
            "
            class="all_data_sub_wrpr_sec"
          >
            <button
              mat-raised-button
              class="subscribed_btn"
              (click)="unsubscribeOpen()"
            >
              Subscribed
            </button>
          </div>
          <div
            *ngIf="
              cookieData?.userinfo?.perennial_subscription_id && !cookieData?.userinfo?.perennial_subscription_status
            "
            class="all_data_sub_wrpr_sec"
          >
            <button
              mat-raised-button
              class="subscribe_btn"
              (click)="subscribeOpen()"
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>
      


      <div class="astrologertarotcer">
          <div class="astrologertarotcer_ATC_B1_sub">
            <h4 class="header">
              Support the Eternal Flame of Divine Wisdom
            </h4>

            <p>Your generous offering sustains the ancient arts of astrology, tarot, and divine theurgy, empowering
              seekers to connect with the infinite. Through your support, our Mystery School thrives, the rituals of the
              gods are preserved, and the timeless practice of Perennial Mandalism flourishes. Together, we weave the
              threads of celestial knowledge and spiritual awakening.</p>

              <div _ngcontent-ng-c3905170804="" class="pdashboard_button_wrapper"><button _ngcontent-ng-c3905170804="">Donate Now</button></div>
          </div>
      </div>

      <div class="new_blockheader" *ngIf="!this.cookieData.userinfo.is_mystery_school">
        <div class="new_blockheader_wrpr">
          <div class="new_blockheader_wrprinner">

            <h4>
              Enter the Sacred Gateway of the Mystery School
            </h4>
            <h5>Awaken your divine potential through transformative training in astrology, tarot, and theurgy. Our
              courses are delivered via live stream sessions, in-depth training videos, and collaborative reading
              opportunities with fellow students. You’ll engage directly with expert instructors, participate in
              breakout sessions for deeper exploration, and enjoy lifetime access to all course materials <strong class="subscription-price">for just $10 per month, per user</strong>.</h5>
            <h6>We are now enrolling for our 2025 Grand Opening, with access to the training center beginning December
              21st, 2025. Seats are limited due to live training schedules, so we encourage early registration to secure
              your place in this sacred journey.</h6>
              
            <div class="pdashboard_button_wrapper">
              <button (click)="registerClick()">Register for the Mystery School</button>
            </div>
          </div>
        </div>

      </div>


      <div class="search_card_wrapper">
        <div class="datepicker_wrapper list-style2">
          <div class="adminlisttable_v2">
            <div class="togglesearchcls">
              <mat-toolbar-row class="mat-toolbar-row searchbar listmaindivbody">
                <mat-form-field appearance="outline">
                  <mat-label>Content Added From (Start Date)</mat-label>
                  <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate" readonly />
                  <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                  <mat-datepicker #startPicker></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Content Added To (End Date)</mat-label>
                  <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate" [min]="startDate" readonly />
                  <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                  <mat-datepicker #endPicker></mat-datepicker>
                </mat-form-field>

                <div class="searchbtncls">
                  <span class="search_class">
                    <mat-icon matTooltip="Refresh" (click)="refreshFields()">refresh</mat-icon>
                    <button matTooltip="Search" mat-icon-button (click)="search()"></button>
                  </span>
                </div>
              </mat-toolbar-row>
            </div>
          </div>
        </div>

        <div class="orders-container">
          <div class="order-card order_card_livestream">
            <div class="order-header">
              <h2>Live Stream</h2>
              <h3>
                {{
                contentCount?.live_stream !== null &&
                contentCount?.live_stream !== undefined
                ? contentCount.live_stream
                : "N/A"
                }}
              </h3>
            </div>
          </div>
          <div class="order-card order_card_videolibrary">
            <div class="order-header">
              <h2>Video Library</h2>
              <h3>
                {{
                contentCount?.video_library !== null &&
                contentCount?.video_library !== undefined
                ? contentCount.video_library
                : "N/A"
                }}
              </h3>
            </div>
          </div>
          <div class="order-card order_card_document">
            <div class="order-header">
              <h2>Document</h2>
              <h3>
                {{
                contentCount?.document !== null &&
                contentCount?.document !== undefined
                ? contentCount.document
                : "N/A"
                }}
              </h3>
            </div>
          </div>
          <div class="order-card order_card_youtubevid">
            <div class="order-header">
              <h2>YouTube Video</h2>
              <h3>
                {{
                contentCount?.youtube_video !== null &&
                contentCount?.youtube_video !== undefined
                ? contentCount.youtube_video
                : "N/A"
                }}
              </h3>
            </div>
          </div>
          <div class="order-card order_card_announcement">
            <div class="order-header">
              <h2>Announcement</h2>
              <h3>
                {{
                contentCount?.announcement !== null &&
                contentCount?.announcement !== undefined
                ? contentCount.announcement
                : "N/A"
                }}
              </h3>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="loader">
        <div class="content-item loader_wrapper">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </ng-container>

      <div class="content-container">
        <ng-container *ngIf="!loader">
          <div *ngFor="let item of contentArray" class="content-item">
            <ng-container [ngSwitch]="item.content_type">
              <!-- Video Library (File) -->
              <div *ngSwitchCase="'Video Library'" class="video-library">
                <div class="container-outerwrap">
                  <div class="video-container">
                    <div class="video_iconwrap" *ngIf="!item.isPlaying">
                      <img class="thumbnail_image" [src]="
                          'https://d37pbainmkhx6o.cloudfront.net/' +
                          item.thumbnail_path.baseurl +
                          item.thumbnail_path.fileservername
                        " alt="" />
                      <button class="play_icon" (click)="playVideo(item)">
                        <i class="fa fa-solid fa-play"></i>
                      </button>
                    </div>
                    <video *ngIf="
                        (item.video_source == 'Video File' ||
                          item.video_source == 'Video URL') &&
                        item.isPlaying
                      " controls [autoplay]="item.isPlaying">
                      <source [src]="
                          item.video_source == 'Video File'
                            ? 'https://d37pbainmkhx6o.cloudfront.net/' +
                              item.file_path.baseurl +
                              item.file_path.fileservername
                            : item.video_url
                        " />
                    </video>
                    <iframe *ngIf="
                        item.video_source == 'YouTube URL' && item.isPlaying
                      " [src]="
                        getSanitizedYouTubeUrlFullUrl(
                          item.youtube_url,
                          item.isPlaying
                        )
                      " width="265" height="150" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen></iframe>
                  </div>
                </div>
                <div class="content-wrapper">
                  <div class="content-wrapper-inner">
                    <div class="identifier_img">
                      <img
                        src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/video_orange.png"
                        alt="" />
                    </div>
                    <h2>{{ item.title }}</h2>
                  </div>

                  <p>{{ item.description }}</p>
                </div>
              </div>

              <!-- YouTube Video -->
              <div *ngSwitchCase="'YouTube Video'" class="youtube-container">
                <div class="container-outerwrap">
                  <div class="video-container">
                    <div class="video_iconwrap" *ngIf="!item.isPlaying">
                      <img class="thumbnail_image" [src]="
                          'https://d37pbainmkhx6o.cloudfront.net/' +
                          item.thumbnail_path.baseurl +
                          item.thumbnail_path.fileservername
                        " alt="" />
                      <button class="play_icon" (click)="playVideo(item)">
                        <i class="fa fa-solid fa-play"></i>
                      </button>
                    </div>
                    <iframe *ngIf="item.isPlaying" [src]="
                        getSanitizedYouTubeUrlFullUrl(
                          item.youtube_url,
                          item.isPlaying
                        )
                      " width="265" height="150" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen></iframe>
                  </div>
                </div>

                <div class="content-wrapper">
                  <div class="content-wrapper-inner">
                    <div class="identifier_img">
                      <img
                        src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/youtube_orange.png"
                        alt="" />
                    </div>
                    <h2>{{ item.title }}</h2>
                  </div>

                  <p>{{ item.description }}</p>
                </div>
              </div>

              <!-- Live Stream -->
              <div *ngSwitchCase="'Live Stream'" class="livestream-container">
                <div class="container-outerwrap">
                  <div class="video-container">
                    <div class="video_iconwrap" *ngIf="!item.isPlaying">
                      <img class="thumbnail_image" [src]="
                          'https://d37pbainmkhx6o.cloudfront.net/' +
                          item.thumbnail_path.baseurl +
                          item.thumbnail_path.fileservername
                        " alt="" />
                      <button class="play_icon" (click)="playVideo(item)">
                        <i class="fa fa-solid fa-play"></i>
                      </button>
                    </div>
                    <ng-container *ngIf="item.stream_source == 0">
                      <video *ngIf="shouldShowVideo(item)" controls [autoplay]="item.isPlaying">
                        <source [src]="item.direct_url || item.embed_url" />
                      </video>

                      <iframe *ngIf="shouldShowIframe(item)" [src]="
                          getSanitizedYouTubeFullUrlEmbed(
                            item.direct_url || item.embed_url,
                            item.isPlaying
                          )
                        " width="265" height="150" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                    </ng-container>
                    <ng-container *ngIf="item.stream_source == 1">
                      <video *ngIf="shouldShowVideo(item)" controls [autoplay]="item.isPlaying">
                        <source [src]="item.direct_url || item.embed_url" />
                      </video>

                      <iframe *ngIf="shouldShowIframe(item)" [src]="
                          getSanitizedYouTubeUrlFullUrl(
                            item.direct_url || item.embed_url,
                            item.isPlaying
                          )
                        " width="265" height="150" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                    </ng-container>
                  </div>
                </div>
                <div class="content-wrapper">
                  <div class="content-wrapper-inner">
                    <div class="identifier_img">
                      <img
                        src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/live-streaming_orange.png"
                        alt="" />
                    </div>
                    <h2>{{ item.title }}</h2>
                  </div>
                  <p>{{ item.description }}</p>
                  <div class="scheduledatetime">
                    <h3>
                      <strong>Premieres On: </strong>
                      {{ item.scheduled_date | date : "yyyy-MM-dd, h:mm a" }}
                    </h3>
                  </div>
                </div>
              </div>

              <!-- Announcement -->
              <div *ngSwitchCase="'Announcement'" class="announcement-container">
                <div class="container-outerwrap">
                  <div class="video-container">
                    <img [src]="
                        'https://d37pbainmkhx6o.cloudfront.net/' +
                        item.thumbnail_path.baseurl +
                        item.thumbnail_path.fileservername
                      " alt="Announcement" class="announcement-image" />
                  </div>
                </div>

                <div class="content-wrapper">
                  <div class="content-wrapper-inner">
                    <div class="identifier_img">
                      <img
                        src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/announcement_orange.png"
                        alt="" />
                    </div>
                    <h2>{{ item.title }}</h2>
                  </div>
                  <p>{{ item.description }}</p>
                  <span class="announcement_link">
                    <strong>Link: </strong>
                    <a [href]="sanitizeUrlRaw(item.link)" target="_blank">
                      {{ item.link }}</a>
                  </span>
                  <div class="scheduledatetime">
                    <h3>
                      <strong>Starting On: </strong>
                      {{ item.display_startdate | date : "yyyy-MM-dd, h:mm a" }}
                    </h3>
                    <h3>
                      <strong>Ends On: </strong>
                      {{ item.display_enddate | date : "yyyy-MM-dd, h:mm a" }}
                    </h3>
                  </div>
                </div>
              </div>

              <!-- Document -->
              <div *ngSwitchCase="'Document'" class="document-container">
                <div class="container-outerwrap">
                  <div class="video-container">
                    <div class="file_link">
                      <img [src]="
                          'https://d37pbainmkhx6o.cloudfront.net/' +
                          item.thumbnail_path.baseurl +
                          item.thumbnail_path.fileservername
                        " alt="View Document" class="clickable-document-image" />
                      <div class="download-icon" matTooltip="Download File" matTooltipPosition="below"
                        (click)="downloadFile(item)">

                      </div>
                    </div>
                  </div>
                </div>
                <div class="content-wrapper">
                  <div class="content-wrapper-inner">
                    <div class="identifier_img">
                      <ng-container [ngSwitch]="item.file_path.type">
                        <img *ngSwitchCase="'application/pdf'"
                          src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/pdf-file-orange.png"
                          alt="PDF Icon" />
                        <img *ngSwitchCase="
                            'application/vnd.openxmlformats-officedocument.presentationml.presentation'
                          "
                          src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/ppt-orange.png"
                          alt="PPT Icon" />
                        <img *ngSwitchCase="
                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                          "
                          src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/docx-orange.png"
                          alt="DOCX Icon" />
                        <img *ngSwitchCase="'text/plain'"
                          src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/txt-file-orange.png"
                          alt="TXT Icon" />
                        <img *ngSwitchDefault
                          src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/document_orange.png"
                          alt="Default Document Icon" />
                      </ng-container>
                    </div>
                    <h2>{{ item.title }}</h2>
                  </div>
                  <p>{{ item.description }}</p>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <div class="astrologertarotcer">
        <div class="astrologertarotcer_ATC_B1_sub">
          <h4 class="header">
            Support the Eternal Flame of Divine Wisdom
          </h4>

          <p>Your generous offering sustains the ancient arts of astrology, tarot, and divine theurgy, empowering
            seekers to connect with the infinite. Through your support, our Mystery School thrives, the rituals of the
            gods are preserved, and the timeless practice of Perennial Mandalism flourishes. Together, we weave the
            threads of celestial knowledge and spiritual awakening.</p>

            <div _ngcontent-ng-c3905170804="" class="pdashboard_button_wrapper"><button _ngcontent-ng-c3905170804="">Donate Now</button></div>
        </div>
    </div>
      
      <div class="new_blockheader" *ngIf="!this.cookieData.userinfo.is_mystery_school">
        <div class="new_blockheader_wrpr">
          <div class="new_blockheader_wrprinner">

            <h4>
              Enter the Sacred Gateway of the Mystery School
            </h4>
            <h5>Awaken your divine potential through transformative training in astrology, tarot, and theurgy. Our
              courses are delivered via live stream sessions, in-depth training videos, and collaborative reading
              opportunities with fellow students. You’ll engage directly with expert instructors, participate in
              breakout sessions for deeper exploration, and enjoy lifetime access to all course materials <strong class="subscription-price">for just $10 per month, per user</strong>.</h5>
            <h6>We are now enrolling for our 2025 Grand Opening, with access to the training center beginning December
              21st, 2025. Seats are limited due to live training schedules, so we encourage early registration to secure
              your place in this sacred journey.</h6>
            <div class="pdashboard_button_wrapper">
              <button (click)="registerClick()">Register for the Mystery School</button>
            </div>
          </div>
        </div>

      </div>

      
    </div>
  </div>
</div>
<app-footer></app-footer>